export default __webpack_public_path__ + "static/media/search-icon.bb8cbfc3.svg";